import { combineRefs } from '@visiba/react-std';
import { ForwardedRef, forwardRef } from 'react';
import { Controller } from 'react-hook-form';
import { useText } from '../../../utils/hooks/use_text';
import { useFormContext } from '../form';
import { InputPropsHelper } from '../form/form.helpers';
import { CellulaInputPhoneNumberRoot, InputPhoneNumberProps } from './input_phone_number_root.component';

function CellulaInputPhoneNumber(props: InputPhoneNumberProps, ref: ForwardedRef<HTMLInputElement>): JSX.Element {
	// biome-ignore lint/correctness/useHookAtTopLevel: suppressed due to migration - should be fixed
	const formContext = useFormContext();
	// biome-ignore lint/correctness/useHookAtTopLevel: suppressed due to migration - should be fixed
	const staticTexts = useText();

	if (formContext == null || props.name == null) {
		return <CellulaInputPhoneNumberRoot {...props} ref={ref} />;
	}

	return (
		<Controller
			control={formContext.control.control}
			name={props.name}
			defaultValue={props.defaultValue}
			rules={{
				...props.options,
				onChange: props.onChange,
				onBlur: props.onBlur,
			}}
			disabled={props.disabled}
			render={({ field, fieldState, formState }) => {
				const inputPropsHelper = new InputPropsHelper(props, staticTexts, fieldState, formState);

				return (
					<CellulaInputPhoneNumberRoot
						{...props}
						{...field}
						optional={inputPropsHelper.isOptional()}
						required={inputPropsHelper.isRequired()}
						readOnly={inputPropsHelper.isReadOnly()}
						invalid={inputPropsHelper.isInvalid()}
						invalidText={inputPropsHelper.invalidText()}
						value={field.value ?? ''}
						defaultValue={undefined}
						ref={combineRefs([ref, field.ref])}
					/>
				);
			}}
		/>
	);
}

/* ########################################################################## */
/* ############################### PUBLIC API ############################### */
/* ########################################################################## */

/**
 * A component to provide a complete set of elements to let the user input
 * content. Including label, input field, error handling, helper text, etc.
 */
const InputPhoneNumber = forwardRef(CellulaInputPhoneNumber);

export type { InputPhoneNumberProps };
export { InputPhoneNumber };
